export class SampleDetails {
    customerReference?: string;
    description?: string;
    comment?: string;
    lotNumber?: string;
    templateCode?: string;
    sampleReference?: string;
    analyticalReportGroupingRule?: string;
    priorityLevel?: string;
    resultTransformation?: string;
    recommendationPublication?: string;
    servingUnitNumeratorName?: string;
    servingUnitNumeratorCode?: string;
    servingUnitDenominatorName?: string;
    servingUnitDenominatorCode?: string;
    servingSize?: number;
    productCode?: string;
    productName?: string;
    groupingCode?: string;
}

